import { render, staticRenderFns } from "./SegmentsForm.vue?vue&type=template&id=3738abd1&"
import script from "./SegmentsForm.vue?vue&type=script&lang=js&"
export * from "./SegmentsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports